import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderNylasCommon = {
  key: 'nylas',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'nylas',
    authUrl: `https://api.us.nylas.com/v3/connect/auth`,
    tokenUrl: `https://api.us.nylas.com/v3/connect/token`,
    scopes: [],
  }),
}

export type ProviderNylasAccountType = {
  email: string
  lastMessageDate?: number
}

export const NYLAS_PARENT_FOLDER_DELIMITERS = ['/', '.']
